import axios from 'axios'

export default {
  loadEvents () {
    return axios.get('events')
  }
}
